import React from "react";


export const DocumentationLink = () => {
    return (
        <div className={"mt-7"}>
            <a href="https://help.oska.com.tr/" className="text-gray-500 dark:text-gray-300"
               target="_blank" rel="noreferrer"> Sorun mu yaşıyorsunuz? Döküman için tıklayın.</a>
        </div>
    )
}